
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import Toasted from 'vue-toasted';
import { KanbanState } from "../kanban.model";
import SignalR from "../SignalR";
import TimeTracking from "./TimeTracking";
import TimeTrackingNavbar from "./TimeTrackingNavbar";
import Spinner from "../../util/Spinner";
import CenterOnParent from "../../util/CenterOnParent";

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'TimeTrackSite',
  components: {
    CenterOnParent,
    OrganigramModal: require('../../organigramModal/organigramModal.vue.html').default,
    SignalR,
    Spinner,
    TimeTracking,
    TimeTrackingNavbar,
    UserLimit: require('../../userlimit/userlimit.vue.html').default,
  },
})
export default class TimeTrackSite extends Vue {
  readonly state = new KanbanState();

  async mounted(): Promise<void> {
    await this.reloadAll();
  }

  async reloadAll(): Promise<void> {
    await this.state.reloadAll(this);
    await (this.$refs.navbar as TimeTrackingNavbar).reloadAll();
    this.$root.$emit('reloaded');
  }

  //watches
  @Watch('state.accounts.selectedItem')
  private accountSelected(): void {
    this.reloadAll();
  }

  @Watch('state.archived')
  private onArchiveChanged(): void {
    this.reloadAll();
  }
}

